import { Component, input, InputSignal, signal } from '@angular/core';
import { IconComponent } from "@kinomap-dev/ng-ui-lib/basics";
import { IconType } from '@kinomap-dev/ng-ui-lib/core';

import { TranslateModule } from '@ngx-translate/core';
@Component({
  selector: 'app-dashboard-element',
  imports: [TranslateModule, IconComponent],
  templateUrl: './dashboard-element.html',
  styleUrl: './dashboard-element.scss',
})
export class DashboardElement {
  icon: InputSignal<IconType> = input.required();
  title: InputSignal<string> = input.required();
  description: InputSignal<string | undefined> = input();

}
